<template>
<div>
    <div class='fw-select-base fw-select-base__week'>
        <FwSelect
            v-model='value'
            label='text'
            :options='options'
            :canNotDelete='true'
            type='filter'
            :searchable='false'
            @input='(selectValue) => onInput(selectValue)'>
        </FwSelect>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-facing-decorator';

import { LangOption } from '@/types/Lang';
import { getStorageLocale } from '@/helpers/auth';

@Component({
    emits: ['setLang'],
})
export default class ChooseSiteLang extends Vue {
    value: LangOption | null = null;
    isMounted: boolean = false;
    options: Array<LangOption> = [
        {
            value: 'fr',
            text: 'Fr',
        },
        {
            value: 'en',
            text: 'En',
        },
    ];

    onInput(selectValue: any) {
        if (this.isMounted) {
            this.$emit('setLang', selectValue);
        }
    }

    created() {
        const storageLocal = getStorageLocale();
        if (storageLocal) {
            const optionLocal = this.options.find(item => item.value === getStorageLocale());
            if (optionLocal) {
                this.value = optionLocal;
            } else {
                this.value = this.options[0];
            }
        } else if (this.user && this.user.locale && !storageLocal) {
            this.value = this.user.locale;
        } else {
            this.value = this.options[0];
        }
    }

    mounted() {
        this.isMounted = true;
    }
}
</script>
